module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("General preface")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The aim of this series of Tyndale Old Testament Commentaries, as it was in the companion volumes on the New Testament, is to provide the student of the Bible with a handy, up-to-date commentary on each book, with the primary emphasis on exegesis. Major critical questions are discussed in the introductions and additional notes, while undue technicalities have been avoided.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("In this series individual authors are, of course, free to make their own distinct contributions and express their own point of view on all controversial issues. Within the necessary limits of space they frequently draw attention to interpretations which they themselves do not hold but which represent the stated conclusions of sincere fellow Christians.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("In the Old Testament in particular no single English translation is adequate to reflect the original text. The authors of these commentaries freely quote various versions, therefore, or give their own translation, in the endeavour to make the more difficult passages or words meaningful today. Where necessary, words from the Hebrew (and Aramaic) Text underlying their studies are transliterated. This will help the reader who may be unfamiliar with the Semitic languages to identify the word under discussion and thus to follow the argument. It is assumed throughout that the reader will have ready access to one, or more, reliable rendering of the Bible in English.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("This commentary on Numbers from Dr Wenham provides a thorough, scholarly exegesis, readily understandable by any reader. He faces up to critical questions such as those of date and ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("authorship, and stresses the difference in theological emphasis between this book and the rest of the Pentateuch. Prominent topics well covered include the character of God, the land, and the people of God; nor does he neglect the Christian use of this book. His study should do much to rescue the book of Numbers from being a little-read, rarely-quoted source of Old Testament texts, and help us to appreciate it as an integral part of Scripture worthy of detailed study in its own right.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Interest in the meaning and message of the Old Testament continues undiminished and it is hoped that this series will thus further the systematic study of the revelation of God and his will and ways as seen in these records. It is the prayer of the editor and publisher, as of the authors, that these books will help many to understand, and to respond to, the Word of God today.")])]), _c('p', {
    staticClass: "sign"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("D. J. Wiseman")])])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0